const CARD_BRAND_LABELS = {
  visa: "Visa",
  v: "Visa",
  mastercard: "Mastercard",
  mc: "Mastercard",
  m: "Mastercard",
  amex: "American Express",
  american_express: "American Express",
  a: "American Express",
  discover: "Discover",
  d: "Discover",
  diners: "Diners Club",
  jcb: "JCB",
  unionpay: "UnionPay",
};

const CARD_BRAND_FROM_FIRST_DIGIT = {
  3: "American Express",
  4: "Visa",
  5: "Mastercard",
  6: "Discover",
};

const normalizeYesNo = (value) =>
  typeof value === "string" && value.trim().toUpperCase() === "Y";

const extractLast4 = (subscriberDetails) => {
  const dedicated = subscriberDetails?.xxsCCLast4;
  if (dedicated && String(dedicated).trim()) {
    return String(dedicated).replace(/\D/g, "").slice(-4);
  }

  const legacy = subscriberDetails?.xxsCCNumber;
  if (!legacy || !String(legacy).trim()) return "";

  const digits = String(legacy).replace(/\D/g, "");
  return digits.slice(-4);
};

const resolveCardBrand = (subscriberDetails, last4Source) => {
  const rawBrand =
    subscriberDetails?.xxsCCBrand || subscriberDetails?.xxsCCType || "";
  const normalized = String(rawBrand).trim().toLowerCase();

  if (normalized && CARD_BRAND_LABELS[normalized]) {
    return CARD_BRAND_LABELS[normalized];
  }

  if (normalized) {
    return rawBrand.charAt(0).toUpperCase() + rawBrand.slice(1);
  }

  const digits = String(last4Source || subscriberDetails?.xxsCCNumber || "")
    .replace(/\D/g, "");
  const firstDigit = digits.charAt(0);

  return CARD_BRAND_FROM_FIRST_DIGIT[firstDigit] || "Card";
};

const formatExpiry = (month, year) => {
  const expMonth = Number(month);
  const expYear = Number(year);

  if (!expMonth || !expYear) return "";

  const twoDigitYear = expYear >= 100 ? expYear % 100 : expYear;
  return `${String(expMonth).padStart(2, "0")}/${String(twoDigitYear).padStart(2, "0")}`;
};

export const getPaymentMethodDisplay = (subscriberDetails) => {
  if (!subscriberDetails) {
    return {
      hasPaymentMethod: false,
      cardBrand: "",
      last4: "",
      expiry: "",
    };
  }

  const last4 = extractLast4(subscriberDetails);
  const expiry = formatExpiry(
    subscriberDetails.xxsCCExpMonth,
    subscriberDetails.xxsCCExpYear,
  );
  const cardBrand = resolveCardBrand(subscriberDetails, last4);

  const explicitFlag =
    subscriberDetails.xxsHasCCYN ??
    subscriberDetails.xxsHasCreditCardYN ??
    subscriberDetails.xxsHasPaymentMethodYN;

  const hasExplicitYes = normalizeYesNo(explicitFlag);
  const hasExplicitNo =
    typeof explicitFlag === "string" &&
    explicitFlag.trim().toUpperCase() === "N";

  const hasMetadata = Boolean(last4);
  const hasPaymentMethod = hasExplicitYes
    ? true
    : hasExplicitNo
      ? false
      : hasMetadata;

  return {
    hasPaymentMethod,
    cardBrand,
    last4,
    expiry,
  };
};
